
import {Component, Prop, Vue} from "vue-property-decorator";
import {KADEME_SECENEKLERI, KADEME_SIRA, ModulYetkiSatiri, YetkiKademe} from "@/enum/YetkiModulleri";

@Component
export default class KademeSecici extends Vue {
  @Prop({type: Object, required: true}) satir!: ModulYetkiSatiri;
  @Prop({type: Boolean, default: false}) readonly!: boolean;
  // Kural 1 kilidi: bu kademeden DÜŞÜK seçenekler kapatılır (null = kilit yok). Üst bileşen,
  // alt başlıklarından biri en az Görüntüle iken bu modüle Görüntüle verir (DEV-2684 Kural 1).
  @Prop({type: String, default: null}) altKilidi!: YetkiKademe | null;
  // Kişiye özel yetki modalı: doluysa seçili pill'in sağ üstünde kullanıcı simgesi gösterilir ve
  // metin ipucu olur. Boş (varsayılan) = matris ekranındaki gibi simge yok.
  @Prop({type: String, default: ""}) ozelIsareti!: string;

  secenekler = KADEME_SECENEKLERI;
  kilitIpucuMetni = "Alt başlık açık olduğu için gerekli";

  // Seçenek, kilit kademesinden daha düşükse (ör. altKilidi=Görüntüle iken Gizli/Görünür-Kapalı).
  secenekKilitli(deger: YetkiKademe): boolean {
    if (!this.altKilidi) {
      return false;
    }
    return (KADEME_SIRA[deger] ?? 0) < (KADEME_SIRA[this.altKilidi] ?? 0);
  }

  // Kilit ikonu yalnız düzenlenebilir satırda ve bir kilit uygulanmışken görünür.
  get kilitGoster(): boolean {
    return !this.readonly && !!this.altKilidi;
  }

  onChange() {
    // v-model satırı zaten günceller; üst bileşen kademe düşünce bayrakları temizler.
    this.$emit("degisti", this.satir.modul);
  }
}
